module.exports = __webpack_public_path__ + "img/图层 19.49872ee9.png";